// 描述：敏感词校验
// 作者：BaiZhiming
// 时间：2016-12-7
'use strict';
angular.module('markSensitiveWordCompareModule', [])
    .directive('markSensitiveWord', ['$timeout', 'sensitiveWordCheckService', 'ueditorService', '$compile', function($timeout, sensitiveWordCheckService, ueditorService, $compile) {
        return {
            scope: {
                checkFinish: '=',
                finishCallback: '&',
                className: '@',
                fontSpacing: '=', // 预设字体和行距等，配合APP渠道
                isClearColor: '=' // 微信渠道，不清除颜色效果
            },
            restrict: 'AE',

            /* template: '<div class="sensitiveWordsLeft col-md-6 col-sm-6">' +
                '<div class="sensitiveWordsLeftBorder">' +
                '<div class="sensitiveWordsHeader scroll-fix-active" trs-scroll-fix="" enable-fix="true" fix-top="47" fix-relative-element="[list=\'list\']" fix-box-element=".creation-pos-el" >此处放功能键、</div>' +
                '<div class="TRS_ueditor"></div>' +
                '</div>' +
                '</div>',*/
            template: '<div class="sensitiveWordsLeft {{className}}">' +
                '<div class="sensitiveWordsLeftBorder">' +
                '<div class="sensitiveWordsHeader scroll-fix-active" trs-scroll-fix="" enable-fix="true" fix-top="47" fix-relative-element="[list=\'list\']" fix-box-element=".creation-pos-el">' +

                /* '<div ng-click="close()" class="closeSensitiveWordsCheck">关闭</div>' +*/
                '<div class="clear"></div>' +
                '<div class="sensitiveWordsLevel">' +
                '<span class="sensitiveWordsLevel_tit" ng-bind="sensitiveWords.length==0?\'没有发现敏感词\':\'包含以下敏感词：\'"></span>' +
                '<ul>' +
                '<li ng-repeat="sensitiveWord in sensitiveWords" ng-bind="sensitiveWord.SENSITIVEWORDS"></li>' +
                '</ul>' +
                '</div>' +
                '<div class="clear"></div>' +
                '</div>' +
                '<div class="TRS_ueditor"></div>' +
                '</div>' +
                '</div>',
            transclude: true,
            replace: true,
            link: function($scope, $element, iAttrs, controller) {
                var ue;
                var sensitiveWordsMap = {};
                var sensitiveWordTime = {}; // 同名敏感词出现次数
                var otherAreaState; // 其他区域初始状态的保存，在关闭敏感词校验的时候恢复原状
                initBoundary();
                contentChange();
                initToolBarHeight();
                initboundaryHeight();
                checkNodifyFormInput();

                /**
                 * [markSensitiveWord description]根据敏感词和敏感词级别来标记htmlcontent
                 * @param  {[string]} htmlContent [description]html正文
                 * @param  {[array]} sensitiveWords [description]敏感词数组
                 * @return {[string]}  htmlContent    [description]标记完成的htmlcontent
                 */
                var promise;
                LazyLoad.css('./components/util/ueditor/service/css/ueditorBuiltInStyles.css?v=2.0');

                function markSensitiveWord(htmlContent) {
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(function() {
                        if (htmlContent !== '') {
                            // sensitiveWordCheckService.getSensitiveWordOfContent(htmlContent).then(function(sensitiveWords) {
                            //     $scope.sensitiveWords = sensitiveWords;
                            //     sensitiveWordsMap = {};
                            //     //构造标红元素
                            //     htmlContent = sensitiveWordCheckService.markSensitiveWord(htmlContent, sensitiveWords, true, function(key, value) {
                            //         sensitiveWordsMap[key] = value;
                            //     });
                            //     sensitiveWordTime = getSameSensitiveWordTimes(htmlContent, sensitiveWords);
                            //     htmlContent = $compile(htmlContent)($scope);
                            //     $(".TRS_ueditor").html(htmlContent);
                            //     bindEvent();
                            // });
                            sensitiveWordCheckService.getAllInputSensitiveWords().then(function(sensitiveWords) {
                                var sensitiveArray = sensitiveWords === false ? [] : sensitiveWords.HTMLCONTENT;
                                $scope.sensitiveWords = checkSensitiveWords(sensitiveArray);
                                sensitiveWordsMap = {};
                                // 构造标红元素
                                htmlContent = sensitiveWordCheckService.markSensitiveWord(htmlContent, sensitiveArray, false, function(key, value) {
                                    sensitiveWordsMap[key] = value;
                                });
                                sensitiveWordTime = getSameSensitiveWordTimes(htmlContent, sensitiveWords);
                                htmlContent = $compile(htmlContent)($scope);
                                $('.TRS_ueditor').html(htmlContent);
                                bindEvent();
                            });
                        } else {
                            $scope.sensitiveWords = [];
                            $('.TRS_ueditor').html('');
                        }
                    }, 500);
                    return promise;
                }

                function contentChange() {
                    ue = UE.getEditor('ueditor');
                    initData();
                    notifyInputToCheck();
                    ue.fireEvent('contentchange'); // 防止编辑器展开高度不够
                    ue.addListener('keyup', function() { // 实时双向绑定开始
                        initData();
                        notifyInputToCheck();
                    });
                    ue.addListener('contentChange', function() { // 实时双向绑定开始
                        initData();
                        notifyInputToCheck();
                    });
                }

                function initData() {
                    var htmlcontent = ue.getContent();
                    htmlcontent = ueditorService.replaceHtmlBlank(htmlcontent);

                    /* htmlcontent = clearColor(htmlcontent);*/
                    if ($scope.isClearColor == undefined) {
                        htmlcontent = clearColor(htmlcontent);
                    }
                    markSensitiveWord(htmlcontent);
                }
                // 初始化工具条高度
                function initToolBarHeight() {
                    var height;
                    var myInterval = setInterval(function() {
                        if ($('.edui-editor-toolbarbox').html() !== undefined) {
                            height = $('.edui-editor-toolbarbox').height();
                            $('.sensitiveWordsHeader').height(height);
                            $('.edui-editor-toolbarbox').resize(function() {
                                height = $(this).height();
                                $('.sensitiveWordsHeader').height(height);
                            });
                            clearInterval(myInterval);
                            return;
                        }
                    }, 10);
                    var promiseChange;
                    $scope.$watch('enterFixArea', function(newVale, oldValue) {
                        var parentHeight = $('.sensitiveWordsLeftBorder').height();
                        var marginTop = (newVale === true ? (height - 15) : 0) + 'px';
                        if (angular.isDefined($scope.fontSpacing)) {$('.TRS_ueditor').css('cssText', 'font-family:' + $scope.fontSpacing.fontType + '!important;font-size:' + $scope.fontSpacing.fontSize + '!important;line-height:' + $scope.fontSpacing.lineSpacing + 'em!important');}
                        $('.TRS_ueditor').css('margin-top', marginTop);
                    });
                }
                // 初始化整体界面高度
                function initboundaryHeight() {
                    var height;
                    var myInterval_ = setInterval(function() {
                        if ($('.edui-editor').html() !== undefined) {
                            height = $('.edui-editor').height();
                            $('.sensitiveWordsLeftBorder').height(height);
                            $('.edui-editor').resize(function() {
                                height = $(this).height();
                                $('.sensitiveWordsLeftBorder').height(height);
                            });
                            clearInterval(myInterval_);
                            return;
                        }
                    }, 10);
                }

                function clearColor(htmlcontent) {
                    if (htmlcontent !== '') {
                        var reg1 = /background-color[\s:]+[^;]*/g;
                        var reg2 = /color[\s:]+[^;]*/g;
                        htmlcontent = htmlcontent.replace(reg2, 'color:black').replace(reg1, 'background-color:white');
                    }
                    return htmlcontent;
                }
                // 获取字符串在文章中出现的次数
                function getStringTime(string, htmlContent) {
                    var dom = document.createElement('div');
                    dom.innerHTML = htmlContent;
                    var content = dom.innerText;
                    var re = new RegExp(string, 'g');
                    var arr = content.match(re) === null ? [] : content.match(re);
                    return arr.length;
                }

                function getSameSensitiveWordTimes(htmlContent, sensitiveWords) {
                    for (var i = 0; i < sensitiveWords.length; i++) {
                        var wordName = sensitiveWords[i].SENSITIVEWORDS;
                        sensitiveWordTime[wordName] = {
                            time: getStringTime(wordName, htmlContent),
                            index: getStringTime(wordName, htmlContent)
                        };
                    }
                    return sensitiveWordTime;
                }

                function bindEvent() {
                    // $timeout(function() {
                    $('.sensitive').each(function(index) {
                        var index = sensitiveWordTime[$(this).html()].time - sensitiveWordTime[$(this).html()].index;
                        sensitiveWordTime[$(this).html()].index--;
                        this.sensitiveWord = sensitiveWordsMap[$(this).html()];
                        this.wordIndex = index;
                        this.wordTime = sensitiveWordTime[$(this).html()].time;
                        $(this).bind('click', function() {
                            $scope.selectSpan = {
                                word: this.sensitiveWord,
                                index: this.wordIndex + 1,
                                time: this.wordTime
                            };
                        });
                    });
                    // }, 1000);
                }

                $scope.replaceSensitive = function() {
                    var htmlContent = ue.getContent();
                    var array = [];
                    htmlContent = htmlContent.replace(/<\/?[^>]*>/g, function(a) {
                        array.push(a);
                        return '$$$___replace___***';
                    });
                    var htmlContentNew = '';
                    var htmlContentArray = htmlContent.split($scope.selectSpan.word.SENSITIVEWORDS);
                    for (var i = 0; i < htmlContentArray.length; i++) {
                        var word = i === ($scope.selectSpan.index - 1) ? $scope.selectSpan.word.SUBSTITUTEWORDS : $scope.selectSpan.word.SENSITIVEWORDS;
                        if (i !== htmlContentArray.length - 1) {htmlContentNew += htmlContentArray[i] + word;} else {htmlContentNew += htmlContentArray[i];}
                    }
                    var j = 0;
                    htmlContentNew = htmlContentNew.replace(/\$\$\$\_\_\_replace\_\_\_\*\*\*/g, function() {
                        return array[j++];
                    });
                    ue.setContent(htmlContentNew);
                    // console.log(htmlContent.match($scope.selectSpan.word.SENSITIVEWORDS));
                };

                $scope.replaceAllSensitive = function() {
                    var htmlContent = ue.getContent();
                    var htmlContentNew = sensitiveWordCheckService.replaceStrWithoutHtml(htmlContent, $scope.selectSpan.word.SENSITIVEWORDS, $scope.selectSpan.word.SUBSTITUTEWORDS);
                    ue.setContent(htmlContentNew);
                };

                function initBoundary() {
                    otherAreaState = {
                        bigFace: angular.isDefined($('.bigFaceDetail').attr('style')) ? $('.bigFaceDetail').attr('style') : '',
                        supportcreation: angular.isDefined($('.bigFaceDetailRigth').attr('style')) ? $('.bigFaceDetailRigth').attr('style') : '',
                        ueditor: $('.bigFaceDetailLeft').attr('class')
                    };
                    $('.bigFaceDetail').attr('style', '');
                    $('.bigFaceDetailLeft').removeClass('col-sm-9').removeClass('col-md-9').removeClass('col-sm-8').addClass('col-md-6').addClass('col-sm-6');
                    $('.bigFaceDetailRigth').attr('style', 'display:none');
                }

                $scope.close = function() {
                    if (angular.isFunction($scope.finishCallback)) {$scope.finishCallback();}
                    $scope.checkFinish = false;
                    $('.bigFaceDetail').attr('style', otherAreaState.bigFace);
                    $('.bigFaceDetailLeft').attr('class', otherAreaState.ueditor);
                    $('.bigFaceDetailRigth').attr('style', otherAreaState.supportcreation);
                    ue.fireEvent('contentchange'); // 防止浏览器宽度恢复后高度不适
                };

                $scope.replaceGroup = function(group) {
                    return group.replace(/\[|\]/g, '');
                };
                // 通知input框也检测敏感词
                function notifyInputToCheck() {
                    $scope.$emit('status.notifyInputMark');
                }
                // 监听来自input的通知
                function checkNodifyFormInput() {
                    $scope.$on('notifyEditorToCheck', function() {
                        initData();
                    });
                }
                // 整理敏感词列表
                function checkSensitiveWords(data) {
                    var hash = {},
                        list = angular.copy(data),
                        sensitiveList = [];
                    if (angular.isDefined(list) && angular.isArray(list)) {
                        for (var i = 0; i < list.length; i++) {
                            if (list[i].ISWORDSGROUP == '1' && !hash[list[i].WORDGROUPS]) {
                                hash[list[i].WORDGROUPS] = true;
                                list[i].SENSITIVEWORDS = list[i].WORDGROUPS.replace(/\[|\]/g, '');
                                sensitiveList.push(list[i]);
                            } else if (list[i].ISWORDSGROUP == '0') {
                                sensitiveList.push(list[i]);
                            }
                        }
                    }
                    return sensitiveList;
                }
            }
        };
    }]);
